<template>
  <v-container fluid>
    <h1 class="py-3">
      <v-btn small fab color="secondary" :to="{ path: this.previousPagePath}"><v-icon>reply</v-icon></v-btn>
      <span v-if="model" class="titleText pl-2">{{this.title}} - {{ model[modelTitleField] }}</span>
      <span v-else class="titleText pl-2">{{this.title}}</span>
    </h1>
    <v-alert v-if="error" :value="true" type="error">
      {{ error }}
    </v-alert>
    <template v-if="model">
      <h4>{{this.title}} Information</h4>
      <div v-for="item in infoTable" :key="item.id">
        {{title}} {{item.key}}: <strong> {{model[item.value]}} </strong>
      </div>
      <v-divider class="my-3"/>
      <h4 class="pb-2"> {{this.childTitle.split(".").join(" ")}} with this {{this.title}}</h4>
      <slot></slot>
    </template>

    <v-btn depressed @click="reconcile()">
      <v-icon right>replay</v-icon>
      <span>Refresh {{this.title}} {{this.childTitle.split(".").join(" ")}}</span>
    </v-btn>

  </v-container>
</template>

<script>
export default {
  name: 'GenericSingle',
  props: {
    title: {
      type: String
    },
    modelTitleField: {
      type: String
    },
    childTitle: {
      type: String
    },
    previousPagePath: {
      type: String
    },
    url: {
      type: String
    },
    apiResponseField: {
      type: String
    },
    reconcileURL: {
      type: String,
      default: undefined
    },
    reconcileQueryField: {
      type: String,
      default: undefined
    },
    infoTable: {
      type: Array
    }
  },
  data () {
    return {
      error: false,
      model: undefined
    }
  },
  async beforeMount () {
    const id = this.$route.params.id
    if (id) {
      try {
        const response = await this.$http.get(this.url + `/${id}`)
        this.model = response.data[this.apiResponseField]
      } catch {
        this.error = `Failed to retrieve ${this.title}.`
      }
    } else {
      this.error = `${this.title} ID not found.`
    }
  },
  methods: {
    async reconcile () {
      try {
        await this.$http({
          baseURL: this.$http.defaults.baseURL.replace('api', 'reconcile'),
          url: `${this.reconcileURL}${this.model[this.reconcileQueryField]}`
        })
      } catch {
        this.error = 'Failed to request Refresh of Names.'
      }
    }
  }
}
</script>

<style>
h1 .titleText {
  vertical-align: middle;
}
</style>
